import { render } from "./DataDoesNotExist.vue?vue&type=template&id=50091731&scoped=true&ts=true&lang=pug"
import script from "./DataDoesNotExist.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataDoesNotExist.vue?vue&type=script&lang=ts&setup=true"

import "./DataDoesNotExist.vue?vue&type=style&index=0&id=50091731&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50091731"]])

export default __exports__